"use client";
import React, { useContext } from "react";
import "./Navbar.css";
import Link from "next/link"; // Update to use Next.js's Link component
import Hamburger from "hamburger-react";
import { UserContext } from "@/context/ContextProvider"; // Import the UserContext
import { auth } from "@/config/firebaseConfig"; // Import Firebase Auth
import { signOut } from "firebase/auth"; // Import signOut
import Image from "next/image";
import carIcon from "@/assets/Navbar/carIcon.svg";
import doorIcon from "../../assets/Navbar/doorIcon.svg";
import { useAsyncRoutePush } from "@/app/helpers/useAsyncRoutePush";

// Lazy Load the svgs
const Logo = React.lazy(() => import("@/assets/svgs/Logo.jsx"));
const NavChevron = React.lazy(() => import("@/assets/svgs/NavChevron"));
const LoginIcon = React.lazy(() => import("@/assets/svgs/LoginIcon"));

function Navbar({
  isSidebarRightOpen,
  setIsSidebarRightOpen,
  setIsSidebarLeftOpen,
}) {
  const handleToggleRight = () => {
    setIsSidebarRightOpen((prev) => !prev);
  };

  const handleToggleLeft = () => {
    setIsSidebarLeftOpen((prev) => !prev);
  };

  const { userData } = useContext(UserContext); // Consume the context

  const asyncPush = useAsyncRoutePush();

  const handleSignOut = async () => {
    try {
      await asyncPush("/");
      await signOut(auth); // Sign out the user
    } catch (error) {
      console.error("Error signing out:", error);
      alert("Fehler beim Abmelden. Bitte versuchen Sie es erneut.");
    }
  };

  return (
    <div className="navbar-container">
      <div className="header">
        <div className="mobile-nav-header">
          {userData?.vorname ? (
            <button
              className="mobile-nav-account-button"
              onClick={handleToggleLeft}
            >
              <p>
                {userData
                  ? `${userData.vorname
                      .charAt(0)
                      .toUpperCase()}${userData.nachname
                      .charAt(0)
                      .toUpperCase()}`
                  : "."}
              </p>
            </button>
          ) : (
            <LoginIcon
              alt="login"
              className="account-login-logo"
              onClick={handleToggleLeft}
            />
          )}

          <Link href="/" passHref className="logo-image">
            <Logo
              className="logo-image"
              alt="Autoeinfachlos Logo"
              color="#1d1d1b"
            />
          </Link>

          <Hamburger
            toggled={isSidebarRightOpen}
            className="mobile"
            toggle={handleToggleRight}
            size={20}
          />
        </div>

        <div className="nav-header">
          <Link href="/" className="logo-image">
            <Logo
              className="logo-image"
              alt="Autoeinfachlos Logo"
              color="#1d1d1b"
            />
          </Link>
          <nav className="navigation">
            <ul className="nav-links">
              <li>
                <Link href="/auto-bewerten" className="links">
                  Auto bewerten
                </Link>
              </li>
              <li>
                <Link href="/auto-verkaufen" className="links">
                  Auto verkaufen
                </Link>
              </li>

              <li>
                <Link href="/so-funktionierts" className="links">
                  So funktioniert’s
                </Link>
              </li>
              <li className="dropdown">
                <div className="dropdown-title-wrapper">
                  <div className="links ueber-uns-hoverlink">Service</div>
                  <NavChevron alt="chevron" className="nav-chevron" />
                </div>
                <ul className="dropdown-menu">
                  <Link
                    href="/auto-bewerten/listenpreis-auto"
                    className="dropdown-links"
                  >
                    <li className="transition">Listenpreis Auto</li>
                  </Link>
                  <Link
                    href="/fahrgestellnummer-pruefen"
                    className="dropdown-links"
                  >
                    <li className="transition">Fahrgestellnummer prüfen</li>
                  </Link>

                  <Link
                    href="/kaputtes-auto-verkaufen"
                    className="dropdown-links"
                  >
                    <li className="transition">Kaputtes Auto verkaufen</li>
                  </Link>
                </ul>
              </li>
              <li className="dropdown">
                <div className="dropdown-title-wrapper">
                  <div className="links ueber-uns-hoverlink">Über uns</div>
                  <NavChevron alt="chevron" className="nav-chevron" />
                </div>

                <ul className="dropdown-menu">
                  <Link href="/ueber-uns" className="dropdown-links">
                    <li className="transition">Über uns</li>
                  </Link>
                  <Link href="/ratgeber" className="dropdown-links">
                    <li className="transition">Ratgeber</li>
                  </Link>
                  <Link href="/faq" className="dropdown-links">
                    <li className="transition">Häufige Fragen</li>
                  </Link>

                  <Link href="/kontaktiere-uns" className="dropdown-links">
                    <li className="transition">Kontaktiere uns </li>
                  </Link>
                </ul>
              </li>

              {userData ? (
                <li className="dropdown">
                  <div className="dropdown-title-wrapper konto-dropdown">
                    <div className="links  mobile-nav-account-button">
                      <p>
                        {userData
                          ? `${userData.vorname
                              .charAt(0)
                              .toUpperCase()}${userData.nachname
                              .charAt(0)
                              .toUpperCase()}`
                          : "."}
                      </p>
                    </div>

                    <p className="">{userData.vorname}</p>
                  </div>
                  <ul className="dropdown-menu">
                    <Link href="/account" className="dropdown-links ">
                      <li className="transition konto-item-wrapper">
                        <Image
                          src={carIcon}
                          alt="carIcon"
                          className="konto-dropdown-icon"
                        />

                        <span>Account</span>
                      </li>
                    </Link>

                    <div
                      className="dropdown-links"
                      onClick={() => handleSignOut()}
                    >
                      <li className="transition konto-item-wrapper">
                        <Image
                          src={doorIcon}
                          alt="signOut"
                          className="konto-dropdown-icon"
                        />

                        <span>Ausloggen</span>
                      </li>
                    </div>
                  </ul>
                </li>
              ) : (
                <>
                  <LoginIcon alt="login" className="account-login-logo" />

                  <Link href="/anmelden" className="links">
                    Konto
                  </Link>
                </>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
